import React, { useCallback } from 'react';
// import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';

import {useTranslation} from 'react-i18next';

function InputDropzone(props) {

  const { onChange, sendAlready, image, 'state-name': stateName } = props;
  const imageEmpty = isEmpty(image);

  const onDrop = useCallback(acceptedFiles => {
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');
    reader.onload = (e) => {
      const base = btoa(reader.result);
      onChange({[stateName]: base}, e, reader);
    };

    acceptedFiles.forEach(file => {
      reader.readAsBinaryString(file);
    });
  }, []);

  function isEmpty(obj) {
    for(const key in obj) {
      if(obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
    onDrop,
    accept: 'image/jpeg, image/png'
  });
  // const { root } = useStyles();
  const { t } = useTranslation();

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  return (
    <section style={{ paddingTop: 30 }} className="container">
      <div disabled={!imageEmpty || sendAlready} hidden={sendAlready} style={{ borderRadius: 5, backgroundColor: '#efefef', padding: 10, borderWidth: 1, borderColor: '#e3e3e3' }} {...getRootProps({className: 'dropzone'})}>
        <input disabled={sendAlready} hidden={sendAlready} {...getInputProps()} />
        {!files.length && !sendAlready && imageEmpty && <p style={{textAlign: 'center'}}>{t('importFile')}</p>}
        {!!files.length && <p style={{textAlign: 'center'}}>{files[0].key}</p>}
      </div>
      {/* {!imageEmpty && image && <img src={`data:image/png;base64,${image}`} alt='' className={classes.image} />} */}
    </section>
  );
}

export default InputDropzone;